// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "accept_marketing": {
      "column": {
        "default": "0",
        "name": "accept_marketing",
        "null": false,
        "type": "boolean"
      },
      "name": "accept_marketing",
      "selected_by_default": null,
      "translated": null
    },
    "accept_terms": {
      "column": {
        "default": "0",
        "name": "accept_terms",
        "null": false,
        "type": "boolean"
      },
      "name": "accept_terms",
      "selected_by_default": null,
      "translated": null
    },
    "activity_in_class": {
      "column": {
        "default": "1",
        "name": "activity_in_class",
        "null": false,
        "type": "boolean"
      },
      "name": "activity_in_class",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "get_started": {
      "column": {
        "default": "1",
        "name": "get_started",
        "null": false,
        "type": "boolean"
      },
      "name": "get_started",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "user_id": {
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      },
      "name": "user_id",
      "selected_by_default": null,
      "translated": null
    },
    "weekly_report_for_your_classes": {
      "column": {
        "default": "1",
        "name": "weekly_report_for_your_classes",
        "null": false,
        "type": "boolean"
      },
      "name": "weekly_report_for_your_classes",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "NotificationSetting",
  "collectionKey": "notification_settings",
  "collectionName": "notification_settings",
  "i18nKey": "notification_setting",
  "camelizedLower": "notificationSetting",
  "name": "NotificationSetting",
  "nameDasherized": "notification-setting",
  "pluralName": "notification_settings",
  "ransackable_associations": [
    {
      "className": "NotificationSetting::Audit",
      "collectionName": "notification_setting_audits",
      "foreignKey": "notification_setting_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "NotificationSettingAudit",
      "through": null
    },
    {
      "className": "NotificationSetting::Audit",
      "collectionName": "notification_setting_audits",
      "foreignKey": "notification_setting_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "NotificationSettingAudit",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "accept_marketing",
      "column": {
        "default": "0",
        "name": "accept_marketing",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "accept_terms",
      "column": {
        "default": "0",
        "name": "accept_terms",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "activity_in_class",
      "column": {
        "default": "1",
        "name": "activity_in_class",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "get_started",
      "column": {
        "default": "1",
        "name": "get_started",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "unsubscribe_token",
      "column": {
        "default": null,
        "name": "unsubscribe_token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "weekly_report_for_your_classes",
      "column": {
        "default": "1",
        "name": "weekly_report_for_your_classes",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "notification_setting",
  "primaryKey": "id"
}

/** Frontend model for NotificationSetting. */
export default class NotificationSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  acceptMarketing() {
    return this.readAttributeUnderscore("accept_marketing")
  }

  /** @returns {boolean} */
  hasAcceptMarketing() {
    const value = this.acceptMarketing()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  acceptTerms() {
    return this.readAttributeUnderscore("accept_terms")
  }

  /** @returns {boolean} */
  hasAcceptTerms() {
    const value = this.acceptTerms()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  activityInClass() {
    return this.readAttributeUnderscore("activity_in_class")
  }

  /** @returns {boolean} */
  hasActivityInClass() {
    const value = this.activityInClass()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  getStarted() {
    return this.readAttributeUnderscore("get_started")
  }

  /** @returns {boolean} */
  hasGetStarted() {
    const value = this.getStarted()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  userId() {
    return this.readAttributeUnderscore("user_id")
  }

  /** @returns {boolean} */
  hasUserId() {
    const value = this.userId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  weeklyReportForYourClasses() {
    return this.readAttributeUnderscore("weekly_report_for_your_classes")
  }

  /** @returns {boolean} */
  hasWeeklyReportForYourClasses() {
    const value = this.weeklyReportForYourClasses()

    return this._isPresent(value)
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
